import { adminApi } from './http';

import { isAdminLoggedIn } from './auth';

export const reportFrontendEvent = (payload) => adminApi.post('/operation-logs/frontend-events', {
  operation: payload.operation || '后台用户行为',
  pagePath: payload.pagePath || window.location.pathname,
  detail: payload.detail || '',
  success: payload.success !== false,
}, {
  skipAdminUnauthorizedHandler: true,
});

export const trackFrontendEvent = (payload) => {
  if (!isAdminLoggedIn()) {
    return Promise.resolve();
  }

  return reportFrontendEvent(payload).catch(() => {});
};

export const fetchOperationLogs = (params = {}) => adminApi.get('/operation-logs', { params });
